import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

import INFO from "../../data/user";

import "./styles/socials.css";

const Socials = () => {
	const [copied, setCopied] = useState(false);

	const handleEmailClick = useCallback(() => {
		navigator.clipboard.writeText(INFO.main.email).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		});
	}, []);

	return (
		<div className="socials">
			<div className="social">
				<a href={INFO.socials.github} target="_blank" rel="noreferrer">
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faGithub}
							className="social-icon"
						/>
					</div>
					<div className="social-text">GitHub</div>
				</a>
			</div>

			<div className="social">
				<a
					href={INFO.socials.linkedin}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faLinkedin}
							className="social-icon"
						/>
					</div>
					<div className="social-text">LinkedIn</div>
				</a>
			</div>

			<div className="email">
				<div
					className={`email-wrapper email-copy${copied ? " email-copy--copied" : ""}`}
					onClick={handleEmailClick}
					role="button"
					tabIndex={0}
					onKeyDown={(e) => e.key === "Enter" && handleEmailClick()}
					aria-label="Copy email address"
				>
					<div className="social-icon">
						<FontAwesomeIcon icon={faEnvelope} />
					</div>
					<div className="social-text">{INFO.main.email}</div>

					<span
						className={`email-toast${copied ? " email-toast--visible" : ""}`}
						aria-live="polite"
					>
						Copied!
					</span>
				</div>
			</div>
		</div>
	);
};

export default Socials;
